import { cn } from "@/app/utils/cn";
import { Checkbox } from "@/view/components/ui/checkbox";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

interface Option {
  value: string;
  label: string;
  subOptions?: Option[];
  commission?: number;
}

interface SelectTableProps {
  options: Option[];
  initialValue?: string[] | string
  setSelectedTables: (tables: string[]) => void
  selectedTables: string[]
}

export const SelectTables = ({
  options,
  initialValue,
  setSelectedTables: setValue,
  selectedTables: value
}: SelectTableProps) => {
  const [openSubOptions, setOpenSubOptions] = useState<{ [key: string]: boolean }>({});

  const handleSelect = (option: Option, checked: boolean, parent?: Option) => {
    if (checked) {
      if (parent?.value?.toUpperCase() === "FGTS" && parent.subOptions) {
        const siblingValues = parent.subOptions.map((s) => s.value);
        const withoutSiblings = value.filter((v) => !siblingValues.includes(v));
        setValue([...withoutSiblings, option.value]);
        return;
      }
      setValue([...value, option.value]);
    } else {
      setValue(value.filter((v) => v !== option.value));
    }
  }

/*   useEffect(() => {
    if (Array.isArray(initialValue)) {
      setValue(initialValue);
    } else {
      if (initialValue) {
        setValue([initialValue]);
      }
    }

  }, [initialValue]); */

  useEffect(() => {
    const toOpen: Record<string, boolean> = {};
    for (const option of options) {
      if (option.subOptions?.some((sub) => initialValue?.includes(sub.value))) {
        toOpen[option.value] = true;
      }
    }
    if (Object.keys(toOpen).length === 0) return;
    setOpenSubOptions((prev) => ({ ...prev, ...toOpen }));
  }, [options]);

  const hasSomeChecked = (subOptions: Option[]) => {
    return subOptions.some((sub) => value.includes(sub.value));
  }

  return (
    <>
      <h1>Selecione as tabelas</h1>
      <ul className="flex flex-col gap-2">
        {options?.map((option) => {
          const checked = option.subOptions?.length ? hasSomeChecked(option.subOptions) : value.includes(option.value);
          const hasSubOptions = !!option.subOptions?.length;

          return (
            <li key={option.value} className={cn("flex flex-col border border-gray-200 rounded-lg ", checked && "border-primary")}>
              {!!hasSubOptions ? (
                <div
                  onClick={() => hasSubOptions && setOpenSubOptions({ ...openSubOptions, [option.value]: !openSubOptions[option.value] })}
                  className="cursor-pointer flex items-center justify-between gap-2 p-3">
                  <label className="text-sm font-medium" htmlFor={option.value}>{option.label}</label>
                  {openSubOptions[option.value] ? (
                    <ChevronUp className="w-4 h-4" />
                  ) : (
                    <ChevronDown className="w-4 h-4" />
                  )}
                </div>

              ) : (
                <div
                  className="flex items-center gap-2 p-3 cursor-pointer"
                  onClick={() => handleSelect(option, !checked)}
                >
                  <Item option={option} checked={checked} onCheckedChange={(option, checked) => handleSelect(option, checked)} />
                </div>
              )}

              {!!hasSubOptions && openSubOptions[option.value] && (
                <ul className="flex flex-col mb-2">
                  {option.subOptions?.map((subOption) => {
                    const subChecked = value.includes(subOption.value);
                    return (
                      <li
                        onClick={() => handleSelect(subOption, !subChecked, option)}
                        key={subOption.value}
                        className="py-3 px-3 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
                        <Item option={subOption} checked={subChecked} onCheckedChange={(subOption, checked) => handleSelect(subOption, checked, option)} />
                      </li>
                    )
                  })}
                </ul>
              )}
            </li>
          )
        })}
      </ul>
    </>
  )
}

const Item = ({ option, checked, onCheckedChange }: { option: Option, checked: boolean, onCheckedChange: (option: Option, checked: boolean) => void }) => {
  return (
    <>
      <Checkbox
        checked={checked}
        className=" data-[state=checked]:border-primary"
        onCheckedChange={(checked: boolean) => onCheckedChange(option, checked)}
      />
      <label className="cursor-pointer text-sm w-full flex items-center justify-between font-medium" htmlFor={option.value}>{option.label}
        {option.commission && (
          <span className="text-sm text-gray-500 font-medium"> comissão: {option.commission}%</span>
        )}
      </label>
    </>
  )
}